





























import {Component, Prop, Vue} from 'vue-property-decorator'
import {IndexSignatureStrOfStr, ShotTypes} from '@/store/shots'

@Component({
  name: 'shot-thumbnail-image',
  filters: {
    durationFormat: (value: number): string => {
      return `${value.toFixed(2)} s`
    }
  }
})
export default class ShotThumbnailImage extends Vue {
  @Prop() title!: string
  @Prop() imageFile!: string
  @Prop() kind!: string
  @Prop() duration!: number
  @Prop() totalDuration!: number
  private imgLoadError = false

  icons: IndexSignatureStrOfStr = {
    still: 'image', video: 'videocam', scene: '3d_rotation', title: 'title',
  }

  get icon(): string {
    return this.icons[this.kind] || this.icons.still
  }

  onLoadSuccess(): void {
    this.imgLoadError = false
  }

  onLoadError(err: any): void {
    this.imgLoadError = true
    this.$log.error(err)
  }

  get showImgLoadError(): boolean {
    return (this.kind !== ShotTypes.Title) && (this.imgLoadError || !this.imageFile)
  }
}
